import { Button } from "antd";
import { useNavigate } from "react-router";

export default function FormButton({
  isPending,
  ActionSaveAndStay,
}: {
  isPending: boolean;
  ActionSaveAndStay?: () => void;
}) {
  const navigate = useNavigate();
  return (
    <div className="w-full flex sticky bottom-0 gap-2 py-5 bg-white left-0 right-0 justify-between items-center z-50">
      <Button
        htmlType="button"
        onClick={() => navigate(-1)}
        danger
        className="text-error-500!"
      >
        بازگشت
      </Button>
      <div className="flex lg:gap-5 gap-2">
        <Button
          loading={isPending}
          htmlType="button"
          onClick={ActionSaveAndStay}
        >
          ذخیره و ایجاد یکی دیگر
        </Button>
        <Button loading={isPending} htmlType="submit" type="primary">
          ذخیره
        </Button>
      </div>
    </div>
  );
}
